<script>
import Icon from '~/components/icon.vue';

export default {
  components: {
    Icon
  },

  props: {
    isClosable: {
      type: Boolean,
      required: false,
      default: true
    },

    message: {
      type: String,
      required: true
    },

    type: {
      type: String,
      required: true
    },

    show: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  emits: ['close'],

  data() {
    return {
      iconName: {
        error: 'mood-cry'
      }
    };
  }
};
</script>

<template>
  <transition>
    <div
      v-if="show"
      class="c-flash-message"
    >
      <icon
        class="me-2"
        :class="`c-flash-message--${type}`"
        :name="iconName[type]"
      />

      <span>{{ message }}</span>

      <div
        v-if="isClosable"
        class="c-flash-message__close_button"
        @click="$emit('close')"
      >
        <icon
          name="x"
          size="small"
        />
      </div>
    </div>
  </transition>
</template>
